import React, { ChangeEvent } from "react"
import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { Mode } from "./ReadWriteTextField"
import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material"

export interface Option {
  value: string|number|boolean, 
  label: string,
}

export const YES_OPTION:Option = {label:"Yes", value:"Yes"}
export const NO_OPTION:Option = {label:"No", value:"No"}

export interface IProps {
  mode: Mode, 
  onChange:(e:ChangeEvent<HTMLInputElement | HTMLOptionElement>) => void
  value?: Option,
  renderParams?: any,
  blankReadOnlyValue?: string,
  options: Option[],
  orientation?: "horizontal" | "vertical",
}

export function ReadWriteOptionGroup(props:IProps):JSX.Element {
  const haveSelected = !!props.options.find(o => o.value === props.value?.value)

  return <RadioGroup 
    aria-readonly={props.mode !== "edit"}
    onChange={(e) => {
      e.preventDefault()
      e.stopPropagation()
      props.onChange(e)     
    }}
    value={props.value?.value}
    row={!props.orientation || props.orientation === "horizontal"}
    aria-orientation={props.orientation || "horizontal"}
  >
      {(props.mode !== "edit" && !props.value?.value && !!props.blankReadOnlyValue) && props.blankReadOnlyValue}
      {props.options.map((option: Option, index:number) => {
        if(props.mode !== "edit" && props.value?.value !== option.value) {
          return <span key={"span" + index}></span>
        }
        
        // We'll do some clever icon-ing to get our text to line up well in read-only mode
        let icon = <RadioButtonUnchecked key={"unchecked" + index} />
        let checkedIcon = <RadioButtonChecked key={"checked" + index}  />
        if(props.mode !== "edit") {
          icon = <RadioButtonUnchecked key={"unchecked" + index}  style={{visibility:"hidden", width:"0"}} />
          checkedIcon = <RadioButtonChecked key={"checked" + index}  style={{visibility:"hidden", width:"0"}} />
        } else if(!!props.value?.value && props.value.value === option.value) {
          icon = <RadioButtonUnchecked key={"unchecked" + index}  />
          checkedIcon = <RadioButtonChecked key={"checked" + index}  />
        }

        const style = props.mode !== "edit" ?{paddingLeft:"0"}:{}
        return <FormControlLabel 
          key={"option" + index}
          value={option.value} 
          control={<Radio style={style} icon={icon} checkedIcon={checkedIcon} value={option.value} />}
          label={option.label} 
        />
      })}
  </RadioGroup>
}